import packsterAxiosInstance from '../../services/axios/PacksterAxiosInstance';

class ProductPageRepository {

  calculatePriceByItemId(data) {
    return packsterAxiosInstance().axios.post('/product-api/rpc/calculate-price/', data)
      .then(response => {
        if (response.status === 200) {
          return response.data
        }
      })
  }

  addToBasketWithPrintData(url, data) {
    return packsterAxiosInstance().axios.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        if (response.status === 200) {
          return response.data
        }
      })
  }
}

export default ProductPageRepository;
